import type { TabType } from '@library/model'
import type { BaseObject } from 'common/types'

import type { SelectionType } from '../../types'
import type { RootState } from '../store'
import { getStore } from '../store'

export const selectTabElementSelectionType = (
  elementType: BaseObject,
  tabType?: TabType,
): SelectionType | undefined => {
  if (!tabType) return
  //TODO
  const state: RootState = getStore().getState()
  const tab = state.tabElementProperties.find(elem => elem.tabType === tabType)

  return tab?.behaviors.find(behavior => behavior.elementType === elementType)?.selectionType
}
